import { render, staticRenderFns } from "./LetterEdit.vue?vue&type=template&id=80fcbc06&scoped=true"
import script from "./LetterEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LetterEdit.vue?vue&type=style&index=0&id=80fcbc06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fcbc06",
  null
  
)

export default component.exports